import { render, staticRenderFns } from "./AdCard.vue?vue&type=template&id=8e8b523a&scoped=true"
import script from "./AdCard.vue?vue&type=script&lang=js"
export * from "./AdCard.vue?vue&type=script&lang=js"
import style0 from "./AdCard.vue?vue&type=style&index=0&id=8e8b523a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8b523a",
  null
  
)

export default component.exports